import { useMemo } from 'react';

import { useStoreContext } from 'features/store';

import { IBaseItem, ISanityItem } from '@rbi-ctg/menu';
import { ItemAvailabilityStatus } from 'enums/menu';
import { ServiceMode } from 'generated/graphql-gateway';
import { useCart } from 'hooks/use-cart';
import { useFeatureMenu } from 'hooks/use-feature-menu';
import { useMenuContext } from 'state/menu';
import { useServiceModeContext } from 'state/service-mode';

import { existsInEntries } from './utils';

export const useMenuFeatureUpsell = () => {
  const { serviceMode } = useServiceModeContext();
  const { store } = useStoreContext();
  const { filterForAvailability } = useMenuContext();
  const { getOneMenuItemAvailability } = useMenuContext();

  const { cartEntries } = useCart();

  const { featureMenu, featureMenuLoading } = useFeatureMenu();

  const upsellType: string = useMemo(() => {
    switch (serviceMode) {
      case ServiceMode.DELIVERY:
        return 'upsellItemsAtCheckoutDelivery';
      default:
        return 'upsellItemsAtCheckoutRestaurant';
    }
  }, [serviceMode]);

  const items: IBaseItem[] = useMemo(() => {
    const selectedItems = featureMenu?.[upsellType] || [];

    const isItemAvailable = (item: IBaseItem) => {
      if (store.isOneMenu) {
        return (
          getOneMenuItemAvailability(item._id).availabilityStatus ===
          ItemAvailabilityStatus.AVAILABLE
        );
      }

      return !!filterForAvailability(item as ISanityItem);
    };

    return selectedItems
      .filter((item: IBaseItem) => !existsInEntries(item, cartEntries))
      .filter(isItemAvailable)
      .slice(0, 5);
  }, [
    cartEntries,
    featureMenu,
    filterForAvailability,
    getOneMenuItemAvailability,
    store.isOneMenu,
    upsellType,
  ]);

  return {
    items,
    loading: featureMenuLoading,
  };
};
